module.exports = __webpack_public_path__ + "media/customizations/valencia/back-b8ec190419054a9be707a15178ae811b.jpg";